import { render, staticRenderFns } from "./EditTab.vue?vue&type=template&id=af0df270"
import script from "./EditTab.vue?vue&type=script&lang=js"
export * from "./EditTab.vue?vue&type=script&lang=js"
import style0 from "./EditTab.vue?vue&type=style&index=0&id=af0df270&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports